<app-tips
  [matIcon]="resolved() ? 'check_circle' : 'warning'"
  [bgColor]="resolved() ? 'var(--resolved-color)' : 'var(--warn-color)'"
  [txtColor]="resolved() ? 'white' : 'black'"
  [matIconColor]="resolved() ? 'white' : 'black'"
>
  <div class="banner-head">
    @if (resolved()) {
      <span class="banner-pill">Résolue</span>
    }
    <span class="banner-title">{{ anomaly().title }}</span>
    <span class="banner-meta">{{ meta() }}</span>
  </div>
  @if (state() === 'EXPANDED') {
    <div class="banner-body" [innerHTML]="anomaly().content | anomalyMarkdown"></div>
  }
  @if (actions()) {
    <div class="banner-actions">
      @if (state() === 'EXPANDED') {
        <button
          mat-icon-button
          aria-label="Réduire le bandeau"
          matTooltip="Réduire"
          (click)="collapse.emit()"
        >
          <svg lucideChevronUp></svg>
        </button>
      } @else {
        <button
          mat-icon-button
          aria-label="Déplier le bandeau"
          matTooltip="Déplier"
          (click)="expand.emit()"
        >
          <svg lucideChevronDown></svg>
        </button>
      }
      @if (resolved()) {
        <button
          mat-icon-button
          aria-label="Fermer le bandeau"
          matTooltip="Fermer"
          (click)="dismiss.emit()"
        >
          <svg lucideX></svg>
        </button>
      }
    </div>
  }
</app-tips>
